import { render, staticRenderFns } from "./specialistdetail.vue?vue&type=template&id=16b3a522&scoped=true&"
import script from "./specialistdetail.vue?vue&type=script&lang=js&"
export * from "./specialistdetail.vue?vue&type=script&lang=js&"
import style0 from "./specialistdetail.vue?vue&type=style&index=0&id=16b3a522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b3a522",
  null
  
)

export default component.exports